import { render, staticRenderFns } from "./rules_editor.vue?vue&type=template&id=63c49f5a"
import script from "./rules_editor.vue?vue&type=script&lang=js"
export * from "./rules_editor.vue?vue&type=script&lang=js"
import style0 from "./rules_editor.vue?vue&type=style&index=0&id=63c49f5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports